"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Contact_1 = __importDefault(require("./Contact"));
const Document_1 = __importDefault(require("./Document"));
const Office_1 = __importDefault(require("./Office"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const Role_1 = __importDefault(require("./Role"));
const OfficeRole_1 = __importDefault(require("./OfficeRole"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const Seats_1 = __importDefault(require("../Admin/Seats"));
const UserOfficeAffiliation_1 = __importDefault(require("./UserOfficeAffiliation"));
class User extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = User;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({
        groups: ["createFolder", "updateFolder", "createVote"],
        message: "UID is required",
    }),
    __metadata("design:type", String)
], User.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "idNot", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createUser"], message: "Contact is required" }),
    (0, classTransformer_1.Type)(() => Contact_1.default),
    __metadata("design:type", Contact_1.default)
], User.prototype, "contact", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createUser"], message: "Office is required" }),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], User.prototype, "office_membership", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], User.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], User.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", Array)
], User.prototype, "office_folders", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Document_1.default),
    __metadata("design:type", Array)
], User.prototype, "documents", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createUser", "auth"], message: "Role is required" }),
    (0, classTransformer_1.Type)(() => Role_1.default),
    __metadata("design:type", Role_1.default)
], User.prototype, "role", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeRole_1.default),
    __metadata("design:type", OfficeRole_1.default)
], User.prototype, "office_role", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Seats_1.default),
    __metadata("design:type", Array)
], User.prototype, "seats", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => UserOfficeAffiliation_1.default),
    __metadata("design:type", Array)
], User.prototype, "office_affiliations", void 0);
